export default __webpack_public_path__ + "static/media/server.2fa51eef.svg";